export default __webpack_public_path__ + "static/media/kit_02.4904a456.jpg";